import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Button } from 'reactstrap';
import LoadingIndicator from '../loading-indicator/loading-indicator';
import ReactGA from 'react-ga'
import { trackingActions } from '../../../core/tracking';

export const StartSection = ({ questionnaire_list, typeQuestionnaire, text, handleNextSection, icon }) => {
    const dispatch = useDispatch();

    function createMarkup() {
        return { __html: text };
    }

    const eventGA = () => {
        ReactGA.event({
            category: 'Questionnaires',
            action: `${typeQuestionnaire} started`
        })
    }

    const ourTracking = () => {
        dispatch(trackingActions.saveTrackingEvent({category: 'Questionnaires', action: `${typeQuestionnaire} started`}))
    }

    return (
        <>
            <Container fluid="md" className='mx-auto p-0 h-100 w-100'>
            {questionnaire_list && !questionnaire_list?.isPending &&
            <div className="pt-md-3 px-md-3 rounded border-md h-100">
                <h2 className='mb-2 libre-caslon-text-regular h3'>{questionnaire_list?.data?.questionnaire?.name}</h2>
                {<div className='mb-4' dangerouslySetInnerHTML={createMarkup()} />}
                <div className="d-flex align-items-center justify-content-center mb-3">
                    { icon && <img src={icon} alt={questionnaire_list?.data?.questionnaire?.name} className="img-fluid mx-auto" width="228" />}
                </div>

                {questionnaire_list.starts_from > 1 ?
                    <Button color='green-light' size='sm' onClick={() => handleNextSection(questionnaire_list.data.questionnaire?.completion == 100 ? 'finish' : 'question')} className="mx-auto px-3 d-block mb-5">
                        <i className="mr-2">
                            <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" fill="currentColor" viewBox="0 0 10.94 9.19" style={{ marginBottom: '2px'}}>
                                <path d="M10.75,5.06l-3.94,3.94c-.12,.12-.29,.19-.46,.19s-.34-.07-.46-.19c-.12-.12-.19-.29-.19-.46s.07-.34,.19-.46l2.82-2.82H.66c-.17,0-.34-.07-.46-.19-.12-.12-.19-.29-.19-.46s.07-.34,.19-.46c.12-.12,.29-.19,.46-.19H8.7L5.88,1.12c-.12-.12-.19-.29-.19-.46s.07-.34,.19-.46,.29-.19,.46-.19,.34,.07,.46,.19l3.94,3.94c.06,.06,.11,.13,.14,.21s.05,.17,.05,.25c0,.09-.02,.17-.05,.25-.03,.08-.08,.15-.14,.21Z"/>
                            </svg>
                        </i>
                        Continue
                    </Button>
                :
                    <Button color='green-light' size='sm' onClick={() => {handleNextSection('question'); eventGA(); ourTracking()}} className="mx-auto px-3 d-block mb-5">
                        <i className="mr-2">
                            <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" fill="currentColor" viewBox="0 0 10.94 9.19" style={{ marginBottom: '2px'}}>
                                <path d="M10.75,5.06l-3.94,3.94c-.12,.12-.29,.19-.46,.19s-.34-.07-.46-.19c-.12-.12-.19-.29-.19-.46s.07-.34,.19-.46l2.82-2.82H.66c-.17,0-.34-.07-.46-.19-.12-.12-.19-.29-.19-.46s.07-.34,.19-.46c.12-.12,.29-.19,.46-.19H8.7L5.88,1.12c-.12-.12-.19-.29-.19-.46s.07-.34,.19-.46,.29-.19,.46-.19,.34,.07,.46,.19l3.94,3.94c.06,.06,.11,.13,.14,.21s.05,.17,.05,.25c0,.09-.02,.17-.05,.25-.03,.08-.08,.15-.14,.21Z"/>
                            </svg>
                        </i>
                        Start Assessment
                    </Button>
                }
            </div>}
            </Container>

            {
                questionnaire_list?.isPending && <LoadingIndicator />
            }
        </>
    )
}
